import axiosInstance from "./axiosInstance";

const uploadService = {
    single: async (file) => {
        try {
            let formData = new FormData()
            formData.append('file', file)
            console.log('Making request ....')
            const response = await axiosInstance.post('/upload', formData);
            console.log(response)
            return response.data
        } catch (error) {
            throw error.response.data
        }
    }
}

export default uploadService
